import React from 'react'
import { SimpleGrid } from '@chakra-ui/react'
import { ConnectedNumberInput } from 'components/FormElements'
import { FaBath, FaBed, FaCar, FaCircle, FaCircleNotch, FaCouch, FaRuler } from 'react-icons/fa'

const Rooms: React.FC<{
  isTabletOrMobile?: boolean
}> = ({ isTabletOrMobile }) => {
  return (
    <>
      <SimpleGrid rowGap={0} columnGap={2} columns={isTabletOrMobile ? 0 : 2}>
        <ConnectedNumberInput
          name="Floor_size"
          unit="m2"
          leftIcon={FaRuler}
          placeholder="e.g 29"
          label="Floor size"
        />
        <ConnectedNumberInput
          name="Bathrooms"
          leftIcon={FaBath}
          placeholder="e.g 1"
          label="Bathrooms"
        />
        <ConnectedNumberInput
          name="Bedrooms"
          leftIcon={FaBed}
          placeholder="e.g 1"
          label="Bedrooms"
        />
        <ConnectedNumberInput
          name="Kitchens"
          leftIcon={FaCircle}
          placeholder="e.g 1"
          label="Kitchens"
        />
        <ConnectedNumberInput
          name="Lounges"
          leftIcon={FaCouch}
          placeholder="e.g 1"
          label="Lounges"
        />
        <ConnectedNumberInput
          name="Dining_rooms"
          leftIcon={FaCircleNotch}
          placeholder="e.g 1"
          label="Dining rooms"
        />
        <ConnectedNumberInput name="Parking" leftIcon={FaCar} placeholder="e.g 1" label="Parking" />
      </SimpleGrid>
    </>
  )
}
export default Rooms
